import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { numberWithCommas } from "../../utility/commonHelpers";
import Session from "../../utility/session";

class TopNav extends Component {
  constructor(props) {
    super(props);
    this._clickHandle = this._clickHandle.bind(this);
  }
  _clickHandle(e) {
    Session.logout();
  }
  render() {
    const current_name = Session.getItem("current_name");

    return (
      <div className="top_nav">
        <div className="nav_menu">
          <nav>
            <div className="nav toggle">
              <a id="menu_toggle">
                <i className="fa fa-bars" />
              </a>
            </div>
            <div className="nav-credits-wrapper">
            <div className="nav-credits">Total Credits Available: <span style={{fontWeight:"bold"}}>{numberWithCommas(this.props.globalAvailableCredits || 0)}</span></div>
            <span>Blocked Credits: <span style={{fontWeight:"bold"}}>{numberWithCommas(this.props.blockedcredits || 0)}</span></span>
            </div>
          </nav>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    globalAvailableCredits: state.emailverificationinfo.globalAvailableCredits,
    blockedcredits: state.emailverificationinfo.blockedcredits
  }
};

export default connect(mapStateToProps)(TopNav);



// WEBPACK FOOTER //
// ./src/components/TopNav/TopNav.js